import { render, staticRenderFns } from "./PromoteRouter.vue?vue&type=template&id=0b512dfd&scoped=true&"
import script from "./PromoteRouter.vue?vue&type=script&lang=js&"
export * from "./PromoteRouter.vue?vue&type=script&lang=js&"
import style0 from "./PromoteRouter.vue?vue&type=style&index=0&id=0b512dfd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b512dfd",
  null
  
)

export default component.exports